'use client';

import React, { useContext } from 'react';
import { AvatarContext } from './AvatarContext';
import { Icon as CoreIcon } from '../Icon';
const IconSizeMap = {
  sm: 'normal',
  md: 'large',
  lg: 'large',
  xl: 'xlarge'
};
export const Icon = ({
  src
}) => {
  const {
    size
  } = useContext(AvatarContext);
  return /*#__PURE__*/React.createElement(CoreIcon.SSR, {
    src: src,
    size: IconSizeMap[size]
  });
};